import { Map } from 'immutable';
import { ACTION_ERROR, ACTION_FETCHING, ACTION_SUCCESS } from '../../constants/action-status';

/**
 * Checks if a specific action is indeed handled by this reducer.
 * @param receivedActionType
 * @param acceptedActions
 */
export const actionPredicate = (receivedActionType, acceptedActions = []) => {
	const actions = Array.isArray(acceptedActions)
		? new Set(acceptedActions)
		: new Set([acceptedActions]);

	return actions.has(receivedActionType);
};

/**
 * Naively merges the payload provided into the reducer's state.
 * @param state
 * @param action
 * @param actions
 * @param withResultKey
 * @returns {*} updated state with payload data
 */
export const mergePayloadIntoState = (state, action, actions, withResultKey = false) => {
	// no status to handle
	if (actionPredicate(action.type, actions)) {
		if (withResultKey) {
			return state.withMutations((state) => {
				state.set(
					'result',
					typeof action.payload === 'object' ? Map(action.payload) : action.payload,
				);
			});
		} else {
			return state.merge(action.payload);
		}
	}
	return state;
};

/**
 * Generates a reducer which takes an entity key and merges the payload naively into the state.
 * @param actions
 * @param withResultKey
 * @param defaultState
 */
export const commonReducerCreator =
	(actions, withResultKey, defaultState = Map()) =>
	(state = defaultState, action = {}) =>
		mergePayloadIntoState(state, action, actions, withResultKey);

/**
 * Parse action type and state.
 *
 * @param action
 * @returns {*}
 */
export const parseActionTypeAndState = (action = {}) => {
	if (!action.type) return {};

	const receivedActionComponents = action.type.split('_');
	const actionType = receivedActionComponents.shift();
	const actionState = receivedActionComponents.shift();

	return Object.assign(
		{
			actionType,
			succeeded: actionState === ACTION_SUCCESS,
			failed: actionState === ACTION_ERROR,
			fetching: actionState === ACTION_FETCHING,
			statusUndefined: actionState === undefined,
			actionState,
		},
		action,
	);
};
